module.exports = __webpack_public_path__ + "img/whatsapp.9425100e.svg";